module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_3_1-0278fcbc95886dddceec82b162f7dc04.webp";